// alterado

import React from 'react'

import EstudoFormProjetoVidaSonhoTracarMeta from '../estudo-form/EstudoFormProjetoVidaSonhoTracarMeta'

import ProjetoVidaSonhoTracarMetaChart from '../estudo-chart/ProjetoVidaSonhoTracarMetaChart'



const EstudoReportProjetoVidaSonhoTracarMeta = ({ values, handleSubmitAutomatico, estudo, jsonConfiguracao, indInicial, indFinal }) => {

    return (
        <>
            <EstudoFormProjetoVidaSonhoTracarMeta
                values={values}
                handleSubmitAutomatico={handleSubmitAutomatico}
                estudo={estudo}
                report={true}
                jsonConfiguracao={jsonConfiguracao}
                indInicial={indInicial}
                indFinal={indFinal}
            />
            {values.exibirHipotesesRetornoRealProjetoVidaSonho && (
                <ProjetoVidaSonhoTracarMetaChart
                    values={values}
                    handleSubmitAutomatico={handleSubmitAutomatico}
                    estudo={estudo}
                    report={true}
                    jsonConfiguracao={jsonConfiguracao}
                    indInicial={indInicial}
                    indFinal={indFinal}
                />
            )}
        </>
    )
}

export default EstudoReportProjetoVidaSonhoTracarMeta